/**
 * Analytics event names following Amplitude 2025 best practices
 * - Use snake_case for event names
 * - Use camelCase for property names
 * - Keep names consistent and self-explanatory
 */

/**
 * Authentication-related events
 */
export const AUTH_EVENTS = {
  /** User encounters an error during callback authentication */
  CALLBACK_ERROR: 'auth_callback_error',

  /** User manually retries after callback error */
  CALLBACK_ERROR_RETRY: 'auth_callback_error_retry',

  /** User successfully completes authentication */
  CALLBACK_SUCCESS: 'auth_callback_success',
} as const;

/**
 * Error boundary events
 */
export const ERROR_EVENTS = {
  /** Error boundary captured an application error */
  BOUNDARY_TRIGGERED: 'error_boundary_triggered',

  /** User clicked reload button to recover from error */
  BOUNDARY_RELOAD: 'error_boundary_reload',

  /** User clicked reset/dismiss button to try again without reload */
  BOUNDARY_RESET: 'error_boundary_reset',
} as const;

/**
 * All analytics events in the application
 * Organized by feature domain
 */
export const ANALYTICS_EVENTS = {
  auth: AUTH_EVENTS,
  error: ERROR_EVENTS,
  // Add other event categories here as needed
  // user: USER_EVENTS,
  // event: EVENT_EVENTS,
  // question: QUESTION_EVENTS,
} as const;
